import { AgeCategory, OrderItem } from '@mews-commander/data-access';
import { LocalizedProperty, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { isOrderItemProductOrder } from '@mews-commander/legacy-entities/src/ducks/orderItemNew';
import { ProductCheckListTableColumn } from '../containers/ProductCheckListTable/types';

export const NO_AGE_CATEGORY_ID = 'none';

export const getAgeCategoryIdentifier = (ageCategoryId: string | null | undefined): string =>
    ageCategoryId ?? NO_AGE_CATEGORY_ID;

export const getAgeCategoryLabel = (ageCategory: AgeCategory | undefined | null) => {
    const identifier = getAgeCategoryIdentifier(ageCategory?.id);

    return identifier !== NO_AGE_CATEGORY_ID && ageCategory ? (
        <LocalizedProperty property={ageCategory.name} />
    ) : (
        lt(TextKey.None)
    );
};

export const getAgeCategoryTotalCellId = (ageCategoryIdentifier: ReturnType<typeof getAgeCategoryIdentifier>) =>
    `${ProductCheckListTableColumn.AgeCategoryTotal}-${ageCategoryIdentifier}`;

export const getOrderItemAgeCategoryIdentifier = (
    orderItem: OrderItem,
    isProductServiceOrder: boolean,
    defaultAgeCategoryId?: string
) => {
    if (isProductServiceOrder || !isOrderItemProductOrder(orderItem)) {
        return getAgeCategoryIdentifier(null);
    }
    return getAgeCategoryIdentifier(orderItem.data.value.ageCategoryId ?? defaultAgeCategoryId);
};
